module.exports = __webpack_public_path__ + "static/media/commercial.be87a7ef.svg";